document.addEventListener("DOMContentLoaded", function () {
  let page = 2;
  let loading = false;
  const trigger = document.getElementById("load-more-trigger");

  if (!trigger) return;

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !loading) {
      loading = true;

      fetch(`${window.location.pathname}?page=${page}&section_id=main-collection`)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data, "text/html");
          const newProducts = html.querySelectorAll("#ProductGridContainer .card-grid > *");

          if (newProducts.length > 0) {
            newProducts.forEach(el => {
              document.querySelector("#ProductGridContainer .card-grid").appendChild(el);
            });
            page += 1;
            loading = false;
          } else {
            observer.disconnect();
          }
        });
    }
  });

  observer.observe(trigger);
});
